 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"90d3d6adf5de87d26efa","1":"3f9f4c56306eabbad2c6","2":"117eb24d1e086a9cb509","3":"8dbe995d89fc10dd6d05","4":"f1c4f2df9c86acb94ff5","5":"603705054bc0e20914cb","6":"8ceced912573d96e173a","7":"8569b3c64067bd2a719d","vendors~Comment~ShareComment":"825e4ace8278b19b9080","vendors~Comment~Survey":"bfde692b8c09e42f25db","vendors~Comment~LoginDialog":"7690ad1b2a545ef7aafb","Comment":"7e1a029e56a75f6770b9","vendors~Player":"20d4c4350c2bea6b028f","AccountOpening":"359e28967949ef0fcc67","BackTopBottom":"a5c543814953b8c9c3aa","Caption":"05ff897cc80113c7fbb1","Copyright":"755c8068519b41c79fe4","DataBox":"c51ae6ae1e0f70e59c2b","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"4d9ad774e09b22113854","Nav":"c3fc7543be0f8cccdf33","NormalCaption":"9e7f349fae8043247b4d","Offline":"db3c64e5744a4dbbe858","QQShare":"b1270346a50f01e32f34","Stick":"52cb9ca2b5e29a7e40d7","Tip":"18a1d4c5958332cac426","ViewMoreLink":"42efa7ec3d7ccb169d25","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"8d0e185c6e7c8464e0d5","Atlas":"138f451a013f969dac4e","FiveNavPic":"5f8262606a3a7df14757","FourNavPic":"936f7e2b513a9c6d9efe","vendors~MdBanner":"64d77b4338b65e58766a","vendors~BigImage~BigImg~BigTopic~BottomSlides~CallupHead~CallupVideoAppHead~HomeFooter~Hongbao~Index~9c339333":"7bfe4fe22b0492e6fa30","CallupVideoAppHead":"f9816fb809532629f541","HomeFooter":"012f4b6a5f9d9594593a","Hongbao":"bfa60ac78b71458795b5","TwoImage":"88fe881d2e9280a4918b","ThreeNavPic":"606dcb8841e691871578","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"a5318d82630c2ea0ef3c","BigImage":"6777673f02f75c3e07ad","NoImage":"f767868bd67946a23566","OneImage":"b52a7c149ac70503fb8d","ThreeImage":"aabaff668c68905377a7","vendors~NewsStream":"55557624707ee716b14a","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"e717639a06f63f09f8db","BigImg":"47a78fda213895bac43b","SingleTitle":"9be353810cda8a911785","SlideImg":"dbeb7ba71cd2c717feb1","TwoImg":"15c70273f6f4771f1c93","vendors~BigTopic~InformationFlow~TitleImg":"02cfd2a69dc4cc9f0704","InformationFlow":"bbf0efd519da869ca652","BigTopic":"e69278c5b9abad3391e2","TitleImg":"12e55348a4016e827b8c","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"fdb6a69360a2ab0ab029","BottomSlides":"294c21a7acb6ce33eff1","IndexSlides":"c9921a8d0cb0a8a32afe","NormalSlides":"3631c9a882fd6307e25c","ShareSlides":"347f89fafeef702f06c5","vendors~UpgradeBottomSlides":"8e71fc7890288cfb2660","vendors~CallupHead":"26a3d5a019ecd9a1730d","vendors~ShareComment":"e6372a5c548888b099a7","vendors~Survey":"7783868b75b3d92806e7","vendors~NormalTabs":"d41ea3e381832981c3c9","vendors~WXGuideLayer":"fea904c3290113621870","LoginDialog":"94396db2ed550aea9fb1","vendors~MarkTabs":"23a7c8d3a646cce3e9fe","vendors~SlidesTabs":"be05daf6cbfe0ccee412"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/content/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
